import React from 'react';
import { Button } from '@material-ui/core';

export default function StartOverButton(props) {
    return (
        <div className='button-startOver'>
            <Button variant='contained' className='float-right mr-2 mt-4' color="primary" onClick={() => props.onStartOver()}>
                START OVER
            </Button>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/StartOverButton.js